export Header from './Layout/Header/Header';

export Footer from './Layout/Footer/Footer';
export { default as Loader } from './Loader/Loader';

export HomeBanner from './HomePage/HomeBanner/HomeBanner';
export HomeCategories from './HomePage/HomeCategories/HomeCategories';
export HomeSales from './HomePage/HomeSales/HomeSales';
export HomeAbout from './HomePage/HomeAbout/HomeAbout';
export HomeTimeline from './HomePage/HomeTimeline/HomeTimeline';

export SurgeryMenu from './Surgery/SurgeryMenu/SurgeryMenu';
export SurgeryContent from './Surgery/SurgeryContent/SurgeryContent';

export DoctorsList from './Doctors/DoctorsList/DoctorsList';
export DoctorDetail from './Doctors/DoctorDetail/DoctorDetail';

export PartnersBanner from './Partners/PartnersBanner/PartnersBanner';
export PartnersTop from './Partners/PartnersTop/PartnersTop';
export PartnersCards from './Partners/PartnersCards/PartnersCards';
export PartnersOthers from './Partners/PartnersOthers/PartnersOthers';
export PartnersSalons from './Partners/PartnersSalons/PartnersSalons';
export PartnerCard from './Partners/PartnerCard/PartnerCard';

export PricingMenu from './Pricing/PricingMenu/PricingMenu';
export PricingContent from './Pricing/PricingContent/PricingContent';

export GalleryMenu from './Gallery/GalleryMenu/GalleryMenu';
export GalleryContent from './Gallery/GalleryContent/GalleryContent';

export ContactPlaces from './Contact/ContactPlaces/ContactPlaces';
export ContactDoctors from './Contact/ContactDoctors/ContactDoctors';
export ContactGallery from './Contact/ContactGallery/ContactGallery';

export ForumMenu from './Forum/ForumMenu/ForumMenu';
export ForumItem from './Forum/ForumItem/ForumItem';
export ForumForm from './ForumForm/ForumForm/ForumForm';

export ProcedureGallery from './Procedure/ProcedureGallery/ProcedureGallery';
export ProcedureDesc from './Procedure/ProcedureDesc/ProcedureDesc';

export News from './News/News/News';

export CookiesBot from './CookiesBot/CookiesBot';



// WEBPACK FOOTER //
// ./src/components/index.js